import React from 'react'

import { useConfigurationStore } from '@stores'

interface ComplianceLabelProps {
    id: string
    label?: string
    value: string
    isMoneyLabel?: boolean
    className?: string
}

const ComplianceLabel: React.FC<ComplianceLabelProps> = ({
    id,
    label,
    value,
    isMoneyLabel = false,
    className = '',
}) => {
    const currency = useConfigurationStore((state) => state.currency)

    return (
        <div className={className}>
            <span id={`${id}-label`} className="text-[#555555]">
                {label}
            </span>
            <span id={`${id}-value`} className="text-[#747474]">
                {value} {isMoneyLabel && currency}
            </span>
        </div>
    )
}

export default ComplianceLabel
